import type { PremiumTier } from '@kaeliux/shared';

/** True when some premium tier offers more queue slots than `tier` does under `limits`. */
export function hasHigherQueueTier(limits: Record<PremiumTier, number>, tier: PremiumTier): boolean {
    return Object.values(limits).some((limit) => limit > limits[tier]);
}
